import SkeletonElement from "@/components/Skeleton/SkeletonElement";

export default function AddEditNoteSideSheetSkeleton() {
  return (
    <div className="space-y-6 mt-6">
      {/* Title Field */}
      <div className="space-y-2">
        <SkeletonElement height="h-4" width="w-16" />
        <SkeletonElement height="h-14" width="w-full" />
        <SkeletonElement height="h-3" width="w-64" />
      </div>

      {/* Note Content Field */}
      <div className="space-y-2">
        <SkeletonElement height="h-4" width="w-24" />
        <SkeletonElement height="h-32" width="w-full" />
      </div>

      {/* Priority Field */}
      <div className="space-y-2">
        <SkeletonElement height="h-4" width="w-16" />
        <SkeletonElement height="h-14" width="w-full" />
        <SkeletonElement height="h-3" width="w-96" />
      </div>

      {/* Expiration Date Field (conditional) */}
      <div className="space-y-2">
        <SkeletonElement height="h-4" width="w-48" />
        <SkeletonElement height="h-14" width="w-full" />
        <SkeletonElement height="h-3" width="w-64" />
      </div>
    </div>
  );
}
